module.exports = __webpack_public_path__ + "img/stonemason.d734864d.png";